// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__1-5dN","Content":"Modal_Content__1iwI6","Message":"Modal_Message__35QzL"};